var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from 'react';
import { useQuery } from 'react-query';
export var useQueryState = function (query) {
    var _a = useState(null), state = _a[0], setState = _a[1];
    useQuery(__assign(__assign({}, query), { onSuccess: function (res) {
            var _a;
            setState(res);
            (_a = query.onSuccess) === null || _a === void 0 ? void 0 : _a.call(query, res);
        } }));
    return state;
};
